var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-autocomplete", {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      placeholder: "请输入姓名或淘金号",
      "trigger-on-focus": false,
      debounce: 500
    },
    on: { select: _vm.handleSelect },
    model: {
      value: _vm.tjkName,
      callback: function($$v) {
        _vm.tjkName = $$v
      },
      expression: "tjkName"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-049e8cfd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-049e8cfd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tjkAutoComplete.vue
// module id = 2003
// module chunks = 0